var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb20"},[_vm._v("页面来源："+_vm._s(_vm.$router.history._startLocation))]),_c('img',{staticStyle:{"width":"100%","height":"99%"},attrs:{"src":_vm.imgArr.error404}})])
}
var staticRenderFns = []

export { render, staticRenderFns }